import React from 'react';

import { Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

import { COLOR_VERIFIED_TICK } from 'src/const';

const VerifiedTag = ({ size }: { size?: 'small' | 'inherit' | 'large' | 'medium' | undefined }) => {
  return (
    <Tooltip title="Airbtics Verified Market" arrow>
      <VerifiedIcon sx={{ color: COLOR_VERIFIED_TICK }} fontSize={size ? size : 'large'} />
    </Tooltip>
  );
};

export default VerifiedTag;
